module.exports = __webpack_public_path__ + "static/media/Pin_flat-tire-icon.5b242353.svg";